function initFileUpload() {
  const fileUploads = document.querySelectorAll('[data-file-upload]');

  if (!fileUploads.length) return;

  fileUploads.forEach(fileUpload => {
    const fileInput = fileUpload.querySelector('[data-file-input]');
    const fileText = fileUpload.querySelector('[data-file-text]');
    const fileTitle = fileUpload.querySelector('[data-file-title]');
    const fileDescription = fileUpload.querySelector('[data-file-description]');

    if (!fileInput || !fileText || !fileTitle) return;

    // Максимальный размер файла в байтах (50 МБ)
    const MAX_FILE_SIZE = 50 * 1024 * 1024;

    // Разрешенные типы файлов
    const ALLOWED_TYPES = [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
      'application/vnd.openxmlformats-officedocument.presentationml.presentation', // pptx
      'application/pdf', // pdf
      'image/jpeg', // jpg
      'image/png' // png
    ];

    // Расширения для дополнительной проверки
    const ALLOWED_EXTENSIONS = ['docx', 'xlsx', 'pptx', 'pdf', 'jpg', 'jpeg', 'png'];

    // Сохраняем оригинальные тексты
    const originalTitle = fileTitle.textContent;
    const originalDescription = fileDescription ? fileDescription.textContent : '';

    // Обработчик клика по области загрузки
    fileUpload.addEventListener('click', () => {
      fileInput.click();
    });

    // Предотвращаем клик по самому input
    fileInput.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    // Обработчик изменения файла
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];

      if (!file) {
        resetFileUpload();
        return;
      }

      // Валидация файла
      const validation = validateFile(file);

      if (validation.isValid) {
        displaySelectedFile(file);
        fileUpload.classList.remove('is-error');
      } else {
        displayError(validation.error);
        fileUpload.classList.add('is-error');
        fileInput.value = '';
      }
    });

    // Drag & Drop функционал
    fileUpload.addEventListener('dragover', (e) => {
      e.preventDefault();
      fileUpload.classList.add('is-dragover');
    });

    fileUpload.addEventListener('dragleave', () => {
      fileUpload.classList.remove('is-dragover');
    });

    fileUpload.addEventListener('drop', (e) => {
      e.preventDefault();
      fileUpload.classList.remove('is-dragover');

      const files = e.dataTransfer.files;
      if (files.length > 0) {
        fileInput.files = files;
        fileInput.dispatchEvent(new Event('change'));
      }
    });

    function validateFile(file) {
      // Проверка размера
      if (file.size > MAX_FILE_SIZE) {
        return {
          isValid: false,
          error: 'Размер файла превышает 50 МБ'
        };
      }

      // Проверка типа файла
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (!ALLOWED_TYPES.includes(file.type) && !ALLOWED_EXTENSIONS.includes(fileExtension)) {
        return {
          isValid: false,
          error: 'Неподдерживаемый тип файла. Разрешены: docx, xlsx, pptx, pdf, jpg, png'
        };
      }

      return { isValid: true };
    }

    function displaySelectedFile(file) {
      const fileName = file.name;
      const fileSize = formatFileSize(file.size);

      fileTitle.textContent = fileName;
      if (fileDescription) {
        fileDescription.textContent = `Размер: ${fileSize}`;
      }

      fileUpload.classList.add('is-selected');
    }

    function displayError(errorMessage) {
      fileTitle.textContent = 'Ошибка';
      if (fileDescription) {
        fileDescription.textContent = errorMessage;
      }
    }

    function resetFileUpload() {
      fileTitle.textContent = originalTitle;
      if (fileDescription) {
        fileDescription.textContent = originalDescription;
      }
      fileUpload.classList.remove('is-selected', 'is-error');
    }

    function formatFileSize(bytes) {
      if (bytes === 0) return '0 Б';

      const k = 1024;
      const sizes = ['Б', 'КБ', 'МБ', 'ГБ'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    }
  });
}

export { initFileUpload };
